<template>
  <login-base-card>
      <div class="content">
          <p class="title">Verifique a mensagem enviada para seu {{ translatedMethod }}.</p>
          <div class="method white">
            <CheckCircleIcon class="method_icon" />
            <p class="method_text">
                {{ methodText }}
            </p>
          </div>
        <RouterLink
          class="link"
          @click="resendLink"
          :text="resendTimer"
          :disabled="!disableResendBtn"
        />
        <RouterLink
          class="link"
          @click="$emit('backLogin')"
          text="Voltar para o login"
        >
          <template slot="icon">
          <ArrowLeftIcon size="20" />
          </template>
        </RouterLink>
      </div>
    </login-base-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ArrowLeftIcon, CheckCircleIcon } from '@vue-hero-icons/outline';
import RouterLink from '@/components/common/Link.vue';
import LoginBaseCard from '@/feature/login/components/LoginBaseCard.vue';

export default {
  metaInfo: {
    title: 'Login',
  },
  components: {
    CheckCircleIcon,
    RouterLink,
    ArrowLeftIcon,
    LoginBaseCard,
  },
  data: () => ({
    disableResendBtn: false,
    timerCount: 30,
    method: null,
    translatedMethod: null,
  }),
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount -= 1;
          }, 1000);
        }

        if (value <= 0) {
          this.disableResendBtn = true;
        }
      },
      immediate: true,
    },

  },
  computed: {
    ...mapState('login', ['hiddenEmail', 'endPhone']),
    resendTimer() {
      if (this.timerCount <= 0) {
        return 'Reenviar link de acesso';
      }
      return `Reenviar link de acesso (${this.timerCount}s)`;
    },
    methodText() {
      return this.method === 'sms'
        ? `Link de acesso enviado para o celular ${this.endPhone}`
        : `Link de acesso enviado por email para ${this.hiddenEmail}`;
    },
  },
  methods: {
    ...mapActions('login', ['sendLink']),
    resendLink() {
      this.timerCount = 30;
      this.sendLink({ method: this.method });
      this.disableResendBtn = false;
    },
  },
  mounted() {
    const { method } = this.$route.params;

    this.method = method;
    this.translatedMethod = method === 'sms'
      ? 'celular'
      : 'email';
  },
};
</script>

<style lang='scss' scoped>

  .content {
    display: flex;
    flex-direction: column;
    animation-name:enter;
    animation-duration:0.3s;

    .title {
      margin: 0.5rem 0 1rem;
      color: #64748B;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
    }

    .method {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      border-radius: 0.75rem;
      font-weight: 600;
      background-color: var(--green-500);

      &_icon {
        display: flex;
        flex-shrink: 0;
        margin: 1.5rem 1rem 3rem 1.5rem;
        width: 1.5rem;
      }

      &_text {
        margin: 1.5rem 1.5rem 1.5rem 0;
      }

      @media (max-width: $sm) {
        &_icon {
          margin: 0.75rem;
          min-width: 1rem;
          width: 1.5rem;
        }

        &_text {
          max-width: -webkit-fill-available;
          margin: 0.75rem;
        }
      }

      @media (max-width: 425px) {
        flex-direction: column;

        &_text {
          margin: 0 0.75rem 0.75rem 0.75rem;
        }
      }
    }

    .link {
      margin-top: 1.25rem;
      align-self: center;
      width: fit-content;

      &:hover {
        color: var(--primary);
        text-decoration: underline;
      }
    }
  }

  @keyframes enter {
    0% {
      opacity:0;
    }

    100% {
      opacity:1;
    }
  }
</style>
